import { createRouter, createWebHistory } from 'vue-router'
import PriceComparison from '../views/PriceComparison.vue'
import BudgetEstimator from '../views/BudgetEstimator.vue'
import InstanceSearch from '../views/InstanceSearch.vue'
import AwsSearchDiscount from '../views/AwsSearchDiscount.vue'

const routes = [
  {
    path: '/',
    redirect: '/awsSearch'
  },
  {
    path: '/awsSearch',
    name: 'InstanceSearch',
    component: InstanceSearch
  },
  {
    path: '/awsSearchDiscount',
    name: 'AwsSearchDiscount',
    component: AwsSearchDiscount
  },
  {
    path: '/compare',
    name: 'PriceComparison',
    component: PriceComparison
  },
  {
    path: '/budget',
    name: 'BudgetEstimator',
    component: BudgetEstimator
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 